export const getServicesFrag = `
    id
    workplaces {
        id
        name
    }
`;
